import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CnEditmodeService {
  editmode = new BehaviorSubject(false);
  loading = new BehaviorSubject(false);
  viewType = new BehaviorSubject('listView');
  tooltipPopup = new BehaviorSubject({
    process_type: '',
    popup_type: '',
    showVideo: false,
    DivergeConvergeVal: false,
    hideOnEditMode: false
  });

  constructor() { }

private STORAGE_KEY = 'CN_FRAMEWORKS';

api = {
  ListFrameworks: (filter: any, limit = 10000): Promise<any> => {
    const all = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
    const items = all.filter(item =>
      item.email === filter.email.eq &&
      item.processTypeId === filter.processTypeId.eq &&
      item.type === filter.type.eq &&
      item.title === filter.title.eq
    );
    return Promise.resolve({ items });
  },

  CreateFramework: (payload: any): Promise<any> => {
    const all = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
    const record = {
      ...payload,
      id: crypto.randomUUID() // Angular 16 safe
    };
    all.push(record);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(all));
    return Promise.resolve(record);
  },

  UpdateFramework: (payload: any): Promise<any> => {
    const all = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
    const index = all.findIndex((i: any) => i.id === payload.id);

    if (index !== -1) {
      all[index] = { ...all[index], ...payload };
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(all));
      return Promise.resolve(all[index]);
    }

    return Promise.reject('Record not found');
  },

  DeleteFramework: (payload: any): Promise<void> => {
    const all = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]')
      .filter((i: any) => i.id !== payload.id);

    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(all));
    return Promise.resolve();
  }
};

public stickChallenge(pin_challenge: any, val = '') {
    pin_challenge = !pin_challenge;
    let headDivHight: any = $('.info.card__headactive').outerHeight();
    let inputDivTop: any = $('.info.card__headactive').offset()?.top;
    let winHeight: any = $(window).outerHeight();
    if (val) {
      if (val == 'ideas') {
        if (pin_challenge) {
          $('.card-body__edit').height(winHeight - headDivHight - inputDivTop - 240);
          $('.card-body__inner').height('auto');
        } else {
          $('.card-body__edit').height('auto');
        }
      } else {
        if (pin_challenge) {
          $('.card-body__inner').height(winHeight - headDivHight - inputDivTop - 165);
          $('.card-body__edit').height('auto');
        } else {
          $('.card-body__inner').height('auto');
        }
      }
    } else {
      if (pin_challenge) {
        $('.card-body__inner').height(winHeight - inputDivTop - 250);
      } else {
        $('.card-body__inner').height('auto');
      }
    }
    return pin_challenge;
  }

  public activeIcon(viewtype: string) {
    this.viewType.next(viewtype);
    if (viewtype == 'gridView') {
      let items = document.querySelectorAll('.editmode__listcol');
      return 'editmode__listrow--grid' + items.length;
    }
    return viewtype;
  }

}

